import React, { useCallback } from 'react';
import useWSWithTopic from 'hooks/useWSWithTopic';
import { inject, observer } from 'mobx-react';

function WSComponent({ store }) {
  const { deliveryStore } = store;

  const handleMessage = useCallback(
    (data) => {
      deliveryStore.handleDropoffUpdate(data);
    },
    [deliveryStore],
  );

  const shipmentId = deliveryStore.delivery?.shipment?.id;
  useWSWithTopic(`customer-shipment_SH_${shipmentId}`, handleMessage, `TToken ${deliveryStore.token}`);

  return null;
}

export default inject('store')(observer(WSComponent));
